import {
  type RecurringDonationPeriodicType,
  RecurringDonationPeriodicTypeEnum,
  type RecurringDonationStatus,
  RecurringDonationStatusEnum
} from '~/types/donations'
import type { OptionsMap } from '~/types/elementsUi'
import { DonationBoxStatus } from '#shared/types/donations'

export const recurringDonationsPeriodicTypeMap = computed<
  Record<RecurringDonationPeriodicType, string>
>(() => {
  const localeIsDutch = useLocaleStore().localeIsDutch

  return {
    [RecurringDonationPeriodicTypeEnum.OneTime]: localeIsDutch ? 'Eenmalig' : 'One-time',
    [RecurringDonationPeriodicTypeEnum.Monthly]: localeIsDutch
      ? 'Maandelijks'
      : 'Monthly',
    [RecurringDonationPeriodicTypeEnum.Quarterly]: localeIsDutch
      ? 'Per kwartaal'
      : 'Quarterly',
    [RecurringDonationPeriodicTypeEnum.Yearly]: localeIsDutch ? 'Jaarlijks' : 'Yearly'
  }
})

export const recurringDonationsPeriodicTypeOptions = computed<
  OptionsMap<RecurringDonationPeriodicType>[]
>(() => {
  return [
    {
      id: RecurringDonationPeriodicTypeEnum.OneTime,
      name: recurringDonationsPeriodicTypeMap.value[
        RecurringDonationPeriodicTypeEnum.OneTime
      ]
    },
    {
      id: RecurringDonationPeriodicTypeEnum.Monthly,
      name: recurringDonationsPeriodicTypeMap.value[
        RecurringDonationPeriodicTypeEnum.Monthly
      ]
    }
  ]
})

export const recurringDonationStatusMap = computed<
  Record<RecurringDonationStatus, string>
>(() => {
  const localeIsDutch = useLocaleStore().localeIsDutch

  return {
    [RecurringDonationStatusEnum.NoPaymentInformation]: localeIsDutch
      ? 'Ontbrekende betaalgegevens'
      : 'Missing payment information',
    [RecurringDonationStatusEnum.Active]: localeIsDutch ? 'Actief' : 'Active',
    [RecurringDonationStatusEnum.Cancelled]: localeIsDutch ? 'Stopgezet' : 'Cancelled'
  }
})

export const donationBoxStatusMap = computed<Record<DonationBoxStatus, string>>(() => {
  const localeIsDutch = useLocaleStore().localeIsDutch

  return {
    [DonationBoxStatus.Active]: localeIsDutch ? 'Actief' : 'Active',
    [DonationBoxStatus.Cancelled]: localeIsDutch ? 'Stopgezet' : 'Cancelled'
  }
})
